import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { NgxLeafletFullscreenModule } from '@runette/ngx-leaflet-fullscreen'
import { SunriseComponent } from './sunrise/sunrise.component';
import { FactWeatherComponent } from './fact-weather/fact-weather.component';
import { TickerStormComponent } from './ticker-storm/ticker-storm.component';
import { StormComponent } from './storm/storm.component';
import { HydroStormComponent } from './hydro-storm/hydro-storm.component';
import { TickerHydroStormComponent } from './ticker-hydro-storm/ticker-hydro-storm.component';
import { LangTranslateComponent } from './lang-translate/lang-translate.component';
import { GTranslateModule } from 'ngx-g-translate';
import { RecordsComponent } from './records/records.component';
import { NewsComponent } from './news/news.component';
import { MapsComponent } from './maps/maps.component';
import { AdssComponent } from './adss/adss.component';
import { DoubleScrollbarComponent } from './double-scrollbar/double-scrollbar.component';
import { ProxyTextComponent } from './proxy-text/proxy-text.component';
import { ForecastMapsComponent } from './forecast-maps/forecast-maps.component';
import { ForecastWeatherComponent } from './forecast-weather/forecast-weather.component';


@NgModule({
  declarations: [
    SunriseComponent,
    FactWeatherComponent,
    TickerStormComponent,
    StormComponent,
    HydroStormComponent,
    TickerHydroStormComponent,
    LangTranslateComponent,
    RecordsComponent,
    NewsComponent,
    MapsComponent, AdssComponent, DoubleScrollbarComponent,
    ForecastMapsComponent,
    ForecastWeatherComponent,
    ProxyTextComponent,
  ],
  imports: [
    CommonModule,
    GTranslateModule,
    RouterModule,
    LeafletModule,
    NgxLeafletFullscreenModule
  ],
  providers: [],
  exports: [
    SunriseComponent,
    FactWeatherComponent,
    TickerStormComponent,
    StormComponent,
    HydroStormComponent,
    TickerHydroStormComponent,
    LangTranslateComponent,
    RecordsComponent,
    NewsComponent,
    MapsComponent,
    AdssComponent,
    DoubleScrollbarComponent,
    ProxyTextComponent,
    ForecastMapsComponent,
    ForecastWeatherComponent
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class WidgetsModule { }
